<template>
  <SvgComponent
    width="64"
    height="64"
    viewBox="0 0 72 72"
    fill="none"
    class="chatbot-icon"
    :class="{ 'hide-path': hidePath }"
  >
    <g>
      <circle
        cx="36"
        cy="36"
        r="36"
        fill="#17494D"
      />
      <path
        d="M52.6667 34.3333C52.6667 29.731 48.9357 26 44.3334 26H27.6667C23.0643 26 19.3334 29.731 19.3334 34.3333C19.3334 38.9357 23.0643 42.6667 27.6667 42.6667H44.3334C48.9357 42.6667 52.6667 38.9357 52.6667 34.3333ZM46 52.6667V46H39.3334L46 52.6667Z"
        fill="white"
      />
    </g>
  </SvgComponent>
</template>

<script>
  import SvgComponent from '../ui/svg-component.vue'

  export default {
    components: {
      SvgComponent,
    },
    props: {
      hidePath: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped>
  .chatbot-icon {
    filter: drop-shadow(0px 20px 28px rgba(4, 68, 77, 0.15));
  }

  .chatbot-icon g path {
    opacity: 1;
    transition: opacity 0.3s ease-out;
  }
  .chatbot-icon.hide-path g path {
    opacity: 0;
  }
</style>
